(function () {
  'use strict';

  const STORAGE_KEY = 'gleecycle:compare-products:v2';
  const LEGACY_STORAGE_KEY = 'gleecycle:compare-products:v1';
  const FEATURE_STORAGE_KEY = 'gleecycle:compare-features:v4';
  const CHANGE_EVENT = 'gleecycle:compare-change';

  const FEATURE_ALIASES = {
    specification: [
      { key: 'battery', aliases: ['Battery', 'Akku', 'Batterie', 'Batteria', 'Bateria', 'Akumulator', 'Batterij', 'Accu'] },
      { key: 'battery-life', aliases: ['Battery life', 'Akkulaufzeit', 'Akkulebensdauer', 'Batterielebensdauer', 'Autonomie de la batterie', 'Duree de vie de la batterie', 'Cicli di ricarica', 'Ciclo di vita della batteria', 'Durata della batteria', 'Czas pracy akumulatora', 'Czas pracy baterii', 'Zywotnosc akumulatora', 'Zywotnosc baterii', 'Accuduur', 'Acculevensduur', 'Batterijduur', 'Batterijlevensduur', 'Levensduur batterij', 'Levensduur van de accu', 'Duracion de la bateria', 'Vida util de la bateria', 'Akun kesto', 'Akun kayttoika'] },
      { key: 'motor', aliases: ['Motor', 'Moteur', 'Motore', 'Silnik', 'Moottori'] },
      { key: 'range', label: 'Range', aliases: ['Range', 'Maximum range', 'Max range', 'Reichweite', 'Autonomie', 'Allineare', 'Autonomia', 'Zasieg', 'Actieradius', 'Bereik', 'Alue', 'Toimintamatka'] },
      { key: 'speed-class', label: 'Speed Class', aliases: ['Speed Class', 'Top speed', 'Max speed', 'Maximum speed', 'Geschwindigkeitsklasse', 'Hochstgeschwindigkeit', 'Categorie de vitesse', 'Classe de vitesse', 'Vitesse maximale', 'Classe di velocita', 'Velocita massima', 'Klasa predkosci', 'Predkosc maksymalna', 'Snelheidsklasse', 'Maximumsnelheid', 'Clase de velocidad', 'Velocidad maxima', 'Nopeusluokka', 'Huippunopeus'] },
      { key: 'charging-time', aliases: ['Charging time', 'Ladezeit', 'Temps de charge', 'Tempo di ricarica', 'Czas ladowania', 'Laadtijd', 'Oplaadtijd', 'Tiempo de carga', 'Latausaika'] },
      { key: 'net-weight', label: 'Net Weight', aliases: ['Net Weight', 'Net Weight of the Bike', 'Bike Weight', 'Eigengewicht', 'Fahrradgewicht', 'Netto-Gewicht', 'Nettogewicht', 'Nettogewicht des Fahrrads', 'Poids du velo', 'Poids net', 'Poids net du velo', 'Peso netto', 'Peso netto della bici', 'Masa netto', 'Masa netto roweru', 'Masa wlasna', 'Waga netto', 'Waga roweru', 'Netto Gewicht', 'Netto gewicht', 'Nettogewicht van de fiets', 'Peso de la bicicleta', 'Peso neto', 'Peso neto de la bicicleta', 'Nettopaino', 'Pyoran nettopaino', 'Pyoran paino'] },
      { key: 'max-load', label: 'Max Load', aliases: ['Max Load', 'Maximum load', 'Max payload', 'Payload capacity', 'Max. Zuladung', 'Maximale Belastung', 'Maximale Zuladung', 'Tragfahigkeit', 'Capacite de charge', 'Charge maximale', 'Capacita di carico', 'Carico massimo', 'Maksymalne obciazenie', 'Udzwig', 'Laadcapaciteit', 'Max. belasting', 'Maximale Belading', 'Maximale Belasting', 'Maximale belasting', 'Capacidad de carga', 'Carga maxima', 'Hyotykuormakapasiteetti', 'Maksimikuorma', 'Max kuormitus'] },
      { key: 'torque', label: 'Torque', aliases: ['Torque', 'Max Torque', 'Drehmoment', 'Maximales Drehmoment', 'Couple', 'Couple maximal', 'Coppia', 'Coppia massima', 'Maksymalny moment obrotowy', 'Moment obrotowy', 'Koppel', 'Maximaal koppel', 'Par', 'Par de apriete', 'Par motor', 'Par maximo', 'Max vaantomomentti', 'Vaanto', 'Vaantomomentti'] },
      { key: 'charger', aliases: ['Charger', 'Ladegerat', 'Chargeur', 'Caricabatterie', 'Ladowarka', 'Lader', 'Oplader', 'Cargador', 'Laturi'] },
      { key: 'climbing-capability', label: 'Climbing Capability', aliases: ['Climbing Capability', 'Gradeability', 'Maximum Climbing degree', 'Maximale Steigfahigkeit', 'Steigfahigkeit', 'Capacite de montee', 'Pente admissible', 'Pente maximale', 'Capacita di salita', 'Massima pendenza superabile', 'Pendenza superabile', 'Maksymalny kat podjazdu', 'Mozliwosc pokonywania wzniesien', 'Zdolnosc pokonywania wzniesien', 'Beklimbaarheid', 'Klimcapaciteit', 'Maximale hellingsgraad', 'Capacidad de ascenso', 'Pendiente maxima de subida', 'Pendiente superable', 'Arvostettavuus', 'Kiipeilykyky', 'Suurin kiipeilyaste'] },
      { key: 'single-battery-bike-weight', aliases: ['Single Battery Version Bike Weight', 'Fahrradgewicht (Einzelakku-Version)', 'Poids du velo version batterie simple', 'Peso versione con batteria singola', 'Waga roweru z pojedyncza bateria', 'Gewicht fiets met enkele batterij', 'Peso de la version con bateria unica', 'Yhden akun version pyoran paino'] },
      { key: 'dual-battery-bike-weight', aliases: ['Dual Batteries Version Bike Weight', 'Fahrradgewicht (Doppelakku-Version)', 'Poids du velo version double batterie', 'Peso versione con doppia batteria', 'Waga roweru z podwojnymi bateriami', 'Gewicht fiets met dubbele batterijen', 'Peso de la version con doble bateria', 'Kaksoisparistoversion pyoran paino'] },
      { key: 'tires', aliases: ['Tires', 'Reifen', 'Pneus', 'Pneumatici', 'Opony', 'Banden', 'Neumaticos', 'Renkaat'] },
      { key: 'material', aliases: ['Material', 'Materiau', 'Materiale', 'Material', 'Materiaal', 'Materiaali'] },
    ],
    mechanical: [
      { key: 'display', aliases: ['Display', 'Anzeige', 'Affichage', 'Ecran', 'Beeldscherm', 'Scherm', 'Wyswietlacz', 'Pantalla', 'Naytto'] },
      { key: 'sensor', aliases: ['Sensor', 'Capteur', 'Sensore', 'Czujnik', 'Anturi'] },
      { key: 'brake', label: 'Brake', aliases: ['Brake', 'Brakes', 'Bremse', 'Bremsen', 'Frein', 'Freins', 'Freno', 'Freni', 'Hamulec', 'Hamulce', 'Rem', 'Remmen', 'Frenos', 'Jarru', 'Jarrut'] },
      { key: 'tire', label: 'Tire', aliases: ['Tire', 'Tires', 'Reifen', 'Pneu', 'Pneus', 'Pneumatico', 'Pneumatici', 'Opona', 'Opony', 'Band', 'Banden', 'Neumatico', 'Neumaticos', 'Rengas', 'Renkaat'] },
      { key: 'saddle', aliases: ['Saddle', 'Sattel', 'Selle', 'Sella', 'Siodelko', 'Siodlo', 'Zadel', 'Sillin', 'Satula'] },
      { key: 'frame', label: 'Frame', aliases: ['Frame', 'Frame Material', 'Material', 'Rahmen', 'Rahmenmaterial', 'Cadre', 'Materiau', 'Materiau du cadre', 'Materiale', 'Materiale del telaio', 'Telaio', 'Material ramy', 'Rama', 'Frame Materiaal', 'Framemateriaal', 'Cuadro', 'Material del cuadro', 'Kehys', 'Materiaali', 'Rungon materiaali', 'Runko', 'Runkomateriaali'] },
      { key: 'front-fork', label: 'Front fork', aliases: ['Front Fork', 'Front fork', 'Suspension fork', 'Federgabel', 'Vordere Gabel', 'Vorderradgabel', 'Fourche', 'Fourche avant', 'Forcella anteriore', 'Przedni widelec', 'Widelec przedni', 'Voorvork', 'Horquilla delantera', 'Etuhaarukka'] },
      { key: 'gearing', label: 'Gearing', aliases: ['Gearing', 'Drivetrain', 'Transmission System', 'Gear', 'Antrieb', 'Antriebssystem', 'Gang', 'Gangschaltung', 'Getriebe', 'Schaltsystem', 'Schaltung', 'Ubersetzung', 'Ubertragungssystem', 'Systeme de transmission', 'Transmission', 'Vitesse', 'Vitesses', 'Cambio', 'Sistema di trasmissione', 'Trasmissione', 'Biegi', 'Naped', 'Przekladnia', 'Przerzutki', 'Przelozenia', 'System napedowy', 'Uklad napedowy', 'Aandrijving', 'Transmissiesysteem', 'Versnelling', 'Versnellingen', 'Pinon', 'Sistema de transmision', 'Transmision', 'Velocidades', 'Vaihteisto', 'Voimansiirto', 'Voimansiirtojarjestelma'] },
      { key: 'rims', label: 'Rims', aliases: ['Rims', 'Wheels', 'Felgen', 'Raeder', 'Jantes', 'Roues', 'Cerchi', 'Cerchioni', 'Ruote', 'Kola', 'Obrecze', 'Velgen', 'Wielen', 'Llantas', 'Ruedas', 'Kiekot', 'Vanteet'] },
      { key: 'chain', aliases: ['Chain', 'Kette', 'Chaine', 'Catena', 'Lancuch', 'Ketting', 'Cadena', 'Ketju'] },
      { key: 'crank', label: 'Crank', aliases: ['Crank', 'Crankset', 'Kurbel', 'Kurbelgarnitur', 'Kurbelsatz', 'Manivelle', 'Pedalier', 'Guarnitura', 'Pedaliera', 'Mechanizm korbowy', 'Korba', 'Crankstel', 'Biela', 'Bielas', 'Kampi', 'Kampisarja'] },
      { key: 'kickstand', aliases: ['Kickstand', 'Seitenstander', 'Stander', 'Bequille', 'Cavalletto', 'Nozka', 'Podporka', 'Standaard', 'Caballete', 'Pata de apoyo', 'Pata de cabra', 'Soporte', 'Tuki'] },
      { key: 'derailleur', aliases: ['Derailleur', 'Schaltwerk', 'Umwerfer', 'Derailleur arriere', 'Deragliatore', 'Przerzutka', 'Cambio trasero', 'Desviador', 'Takavaihtaja', 'Vaihteenvaihtaja'] },
      { key: 'handlebar', label: 'Handlebar', aliases: ['Handlebar', 'Handlebar Aluminum', 'Aluminum Handlebar', 'Lenker', 'Lenker & Vorbau', 'Guidon', 'Guidon et potence', 'Manubrio', 'Manubrio e attacco', 'Kierownica', 'Kierownica i mostek', 'Stuur', 'Stuur en stuurpen', 'Manillar', 'Manillar y potencia', 'Ohjaustanko', 'Ohjaustanko ja stemmi'] },
      { key: 'lighting', label: 'Lighting', aliases: ['Light', 'Lights', 'Lighting', 'Front Light', 'Headlights', 'Beleuchtung', 'Lampe', 'Lichter', 'Frontlicht', 'Scheinwerfer', 'Eclairage', 'Eclairages', 'Eclairage avant', 'Phares', 'Illuminazione', 'Luce', 'Luci', 'Luce anteriore', 'Fari anteriori', 'Faro anteriore', 'Oswietlenie', 'Swiatla', 'Przednie swiatlo', 'Reflektory', 'Licht', 'Verlichting', 'Koplampen', 'Voorlicht', 'Iluminacion', 'Luces', 'Luz', 'Faros delanteros', 'Luz delantera', 'Kevyt', 'Valaistus', 'Valot', 'Ajovalot', 'Etuvalo'] },
      { key: 'rear-suspension', aliases: ['Rear Suspension', 'Rear suspension', 'Hinterradfederung', 'Suspension arriere', 'Sospensione posteriore', 'Amortyzacja tylna', 'Tylne zawieszenie', 'Zawieszenie tylne', 'Achtervering', 'Suspension trasera', 'Takajousitus'] },
      { key: 'pedals', aliases: ['Pedals', 'Pedale', 'Pedales', 'Pedali', 'Pedaly', 'Pedalen', 'Polkimet'] },
      { key: 'rear-light', aliases: ['Rear Light', 'Rucklicht', 'Feu arriere', 'Luce posteriore', 'Tylne swiatlo', 'Achterlicht', 'Luz trasera', 'Takavalo'] },
      { key: 'chainring', aliases: ['Chainring', 'Plateau', 'Corona', 'Tandwiel', 'Plato', 'Ketjurengas'] },
      { key: 'charger', aliases: ['Charger', 'Ladegerat', 'Chargeur', 'Caricabatterie', 'Ladowarka', 'Oplader', 'Cargador', 'Laturi'] },
      { key: 'fender', label: 'Fender', aliases: ['Fender', 'Mudguard', 'Schutzblech', 'Garde-boue', 'Parafango', 'Blotnik', 'Spatbord', 'Guardabarros', 'Lokasuoja'] },
      { key: 'rear-bracket', aliases: ['Rear bracket', 'Gepaecktraeger', 'Porte-bagages arriere', 'Portapacchi posteriore', 'Tylny bagaznik', 'Achterdrager', 'Portaequipajes trasero', 'Takateline'] },
      { key: 'wires', aliases: ['Wires', 'Kabel', 'Fils', 'Cavi', 'Przewody', 'Draden', 'Cables', 'Johdot'] },
      { key: 'shifter', aliases: ['Shifter', 'Schalthebel', 'Manette de derailleur', 'Leva del cambio', 'Manetka', 'Versteller', 'Palanca de cambios', 'Vaihde'] },
      { key: 'wheel-hub', aliases: ['wheel hub', 'Radnabe', 'Moyeu de roue', 'Mozzo ruota', 'Piasta kola', 'Wielnaaf', 'Buje de rueda', 'Pyoran napa'] },
      { key: 'torque', aliases: ['Torque', 'Drehmoment', 'Couple', 'Coppia', 'Moment obrotowy', 'Koppel', 'Par', 'Vaanto', 'Vaantomomentti'] },
      { key: 'suspension', aliases: ['Suspension', 'Federung', 'Suspension', 'Sospensione', 'Zawieszenie', 'Vering', 'Suspension', 'Jousitus'] },
      { key: 'controller', aliases: ['Controller', 'Kontroler', 'Controleur', 'Controlador', 'Ohjain'] },
      { key: 'motor', aliases: ['Motor', 'Moteur', 'Motore', 'Silnik', 'Moottori'] },
    ],
    sizeImage: [
      { key: 'applicable-height', label: 'Applicable Height', aliases: ['Applicable Height', 'Recommended Rider Height', 'Rider Height', 'Ride Height', 'Anwendbare Korpergrosse', 'Einheitsgrosse', 'Empfohlene Fahrergrosse', 'Empfohlene Korpergrosse', 'Fahrergrosse', 'Fahrerhohen', 'Geeignete Korpergrosse', 'Hauteur applicable', 'Hauteur du cycliste', 'Taille applicable', 'Taille du cycliste', 'Taille recommandee', 'Taille recommandee du cycliste', 'Altezza applicabile', 'Altezza ciclista', 'Altezza consigliata', 'Altezza consigliata del ciclista', 'Altezza del ciclista', 'Dopuszczalny wzrost', 'Dostepna wysokosc', 'Dostepny wzrost', 'Dotyczy wzrostu', 'Odpowiedni wzrost', 'Wysokosc jazdy', 'Wysokosc uzytkownika', 'Wzrost jezdzca', 'Wzrost uzytkownika', 'Zalecana wysokosc jezdzca', 'Aanbevolen rijder lengte', 'Geschikte Lengte', 'Geschikte lichaamslengte', 'Rijder lengte', 'Rijhoogte', 'Toepasselijke lengte', 'Zithoogte', 'Altura Aplicable', 'Altura del ciclista', 'Altura recomendada', 'Altura recomendada del ciclista', 'Ajokorkeus', 'Sopiva pituus', 'Sovellettava korkeus', 'Suositeltu ratsastajan korkeus'] },
      { key: 'folded-size', label: 'Folded Size', aliases: ['Folded Size', 'Folding size', 'Folded dimensions', 'Faltmass', 'Gefaltete Grosse', 'Dimensions plie', 'Dimensions pliees', 'Taille pliee', 'Dimensioni da chiuso', 'Dimensioni da piegata', 'Dimensioni piegata', 'Dimensioni piegate', 'Dimensioni piegato', 'Rozmiar po zlozeniu', 'Wymiary po zlozeniu', 'Zlozony rozmiar', 'Opgevouwen Afmetingen', 'Tamano plegado', 'Taitettu koko', 'Taitettuna'] },
    ],
  };

  const FEATURE_PRODUCT_OVERRIDES = {
    specification: {
      'lankeleisi-rv800-plus': { 'bafang motor': 'battery-life', drehmoment: 'motor' },
    },
    mechanical: {
      'engwe-ep-2-3-0-boost': { korba: 'chainring' },
      'engwe-l20-boost': { pedale: 'crank' },
    },
  };

  function readStorage(key) {
    try {
      const value = JSON.parse(window.localStorage.getItem(key));
      return Array.isArray(value) ? value.filter(Boolean).map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Selection still works for the current page when storage is unavailable.
    }
  }

  function unique(values) {
    return [...new Set(values.filter(Boolean).map(String))];
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function selectedFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('compare') || params.get('products') || '';
    return unique(raw.split(',').map((handle) => handle.trim()));
  }

  function updateCompareUrl(handles) {
    const url = new URL(window.location.href);
    if (handles.length) url.searchParams.set('compare', handles.join(','));
    else url.searchParams.delete('compare');
    url.searchParams.delete('products');
    window.history.replaceState({}, '', url);
  }

  function announce(element, message) {
    if (!element) return;
    element.textContent = message || '';
  }

  function broadcast(handles) {
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles } }));
  }

  function initSeries(root) {
    if (root.dataset.compareInitialized === 'true') return;
    root.dataset.compareInitialized = 'true';

    const scope = root.closest('.shopify-section') || root.parentElement || document;
    const toggles = [...scope.querySelectorAll('[data-series-compare-toggle]')];
    const bar = root.querySelector('[data-series-compare-bar]');
    const count = root.querySelector('[data-series-compare-count]');
    const names = root.querySelector('[data-series-compare-names]');
    const button = root.querySelector('[data-series-compare-submit]');
    const cardButtons = [...scope.querySelectorAll('[data-series-compare-card-submit]')];
    const status = root.querySelector('[data-series-compare-status]');
    const maxProducts = Math.max(2, Number(root.dataset.maxProducts || 4));
    const minimumProducts = Math.max(1, Number(root.dataset.minimumProducts || 2));
    const compareUrl = root.dataset.compareUrl || '/pages/compare';
    const limitMessage = root.dataset.limitMessage || `You can compare up to ${maxProducts} products.`;
    const minimumMessage = root.dataset.minimumMessage || `Select at least ${minimumProducts} products.`;

    function getSelected() {
      const stored = readStorage(STORAGE_KEY);
      if (stored.length) return unique(stored).slice(0, maxProducts);

      const legacy = readStorage(LEGACY_STORAGE_KEY);
      const migrated = legacy
        .map((value) => {
          const toggle = toggles.find(
            (item) => String(item.dataset.productId) === value || String(item.dataset.productHandle) === value
          );
          return toggle ? String(toggle.dataset.productId || '') : '';
        })
        .filter(Boolean);
      if (migrated.length) writeStorage(STORAGE_KEY, unique(migrated));
      return unique(migrated).slice(0, maxProducts);
    }

    function render() {
      const selected = getSelected();
      const titleMap = new Map(
        toggles.map((toggle) => [String(toggle.dataset.productId), toggle.dataset.productTitle || toggle.dataset.productHandle])
      );

      toggles.forEach((toggle) => {
        const isSelected = selected.includes(String(toggle.dataset.productId));
        const choice = toggle.closest('[data-product-card-compare-choice]');
        toggle.checked = isSelected;

        if (choice) {
          const defaultLabel = choice.querySelector('[data-product-card-compare-default]');
          const selectedLabel = choice.querySelector('[data-product-card-compare-selected]');
          const cardCount = choice.querySelector('[data-series-compare-card-count]');
          const cardButton = choice.querySelector('[data-series-compare-card-submit]');
          choice.classList.toggle('is-selected', isSelected);
          if (defaultLabel) defaultLabel.hidden = isSelected;
          if (selectedLabel) selectedLabel.hidden = !isSelected;
          if (cardCount) cardCount.textContent = String(selected.length);
          if (cardButton) {
            cardButton.hidden = !isSelected;
            cardButton.disabled = selected.length < minimumProducts;
          }
        }
      });

      if (count) count.textContent = String(selected.length);
      if (names) names.textContent = selected.map((handle) => titleMap.get(handle) || handle).join(' / ');
      if (button) {
        button.disabled = selected.length < minimumProducts;
        button.setAttribute('aria-disabled', String(selected.length < minimumProducts));
      }
      if (bar) bar.hidden = selected.length === 0;
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('change', () => {
        const productId = String(toggle.dataset.productId || '');
        let selected = getSelected();

        if (toggle.checked && !selected.includes(productId)) {
          if (selected.length >= maxProducts) {
            toggle.checked = false;
            announce(status, limitMessage);
            return;
          }
          selected.push(productId);
        } else if (!toggle.checked) {
          selected = selected.filter((item) => item !== productId);
        }

        selected = unique(selected).slice(0, maxProducts);
        writeStorage(STORAGE_KEY, selected);
        announce(status, '');
        render();
        broadcast(selected);
      });
    });

    function submitComparison() {
      const selected = getSelected();
      if (selected.length < minimumProducts) {
        announce(status, minimumMessage);
        return;
      }
      const url = new URL(compareUrl, window.location.origin);
      url.searchParams.set('compare', selected.join(','));
      window.location.assign(url.toString());
    }

    if (button) button.addEventListener('click', submitComparison);
    cardButtons.forEach((cardButton) => cardButton.addEventListener('click', submitComparison));

    document.addEventListener(CHANGE_EVENT, render);
    render();
  }

  function normalizeRows(value) {
    if (!value || !Array.isArray(value.rows)) return [];
    return value.rows
      .filter((row) => Array.isArray(row) && row.length > 0 && row[0] != null)
      .map((row) => [String(row[0]), row[1] == null || row[1] === '' ? '-' : String(row[1])]);
  }

  function normalizeFeatureLabel(label) {
    return String(label)
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/\p{M}+/gu, '')
      .replace(/\u00df/g, 'ss')
      .replace(/\u0142/g, 'l')
      .replace(/\u00f8/g, 'o')
      .replace(/\u00e6/g, 'ae')
      .replace(/\u0153/g, 'oe')
      .replace(/&/g, ' and ')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim();
  }

  function canonicalFeature(groupKey, label, productHandle) {
    const normalizedLabel = normalizeFeatureLabel(label);
    const groupOverrides = FEATURE_PRODUCT_OVERRIDES[groupKey] || {};
    const productOverrides = groupOverrides[String(productHandle || '')] || {};
    const overrideKey = productOverrides[normalizedLabel];
    const alias = (FEATURE_ALIASES[groupKey] || []).find((item) =>
      item.aliases.some((candidate) => normalizeFeatureLabel(candidate) === normalizedLabel)
    );
    const language = document.documentElement ? document.documentElement.lang : 'en';
    const useEnglishLabel = !language || /^en(?:-|$)/i.test(language);
    return {
      key: overrideKey || (alias ? alias.key : normalizedLabel),
      label: alias && alias.label && useEnglishLabel ? alias.label : String(label).trim(),
    };
  }

  function buildGroups(products, labels) {
    const definitions = [
      { key: 'specification', label: labels.specification },
      { key: 'mechanical', label: labels.mechanical },
      { key: 'sizeImage', label: labels.sizeImage, allowedKeys: ['applicable-height', 'folded-size'] },
    ];

    return definitions.map((definition) => {
      const rows = [];
      const seen = new Set();

      products.forEach((product) => {
        const occurrences = new Map();
        normalizeRows(product[definition.key]).forEach(([label]) => {
          const feature = canonicalFeature(definition.key, label, product.handle);
          if (definition.allowedKeys && !definition.allowedKeys.includes(feature.key)) return;

          const occurrence = (occurrences.get(feature.key) || 0) + 1;
          occurrences.set(feature.key, occurrence);
          const key = `${definition.key}::${feature.key}::${occurrence}`;
          if (!seen.has(key)) {
            seen.add(key);
            rows.push({ key, label: feature.label });
          }
        });
      });

      return { ...definition, rows };
    });
  }

  function productValueMap(product, group) {
    const values = new Map();
    const occurrences = new Map();
    normalizeRows(product[group.key]).forEach(([label, value]) => {
      const feature = canonicalFeature(group.key, label, product.handle);
      const occurrence = (occurrences.get(feature.key) || 0) + 1;
      occurrences.set(feature.key, occurrence);
      values.set(`${group.key}::${feature.key}::${occurrence}`, value);
    });
    return values;
  }

  function renderProductReview(product) {
    const rating = Number(product.rating);
    const ratingCount = Number(product.ratingCount);
    if (!Number.isFinite(rating) || !Number.isFinite(ratingCount) || ratingCount < 1) return '';

    const normalizedRating = Math.min(5, Math.max(0, rating));
    const ratingText = normalizedRating.toFixed(1);
    const fillWidth = `${(normalizedRating / 5) * 100}%`;
    const stars = '&#9733;&#9733;&#9733;&#9733;&#9733;';

    return `<a href="${escapeHtml(product.url)}#looxReviews" class="product-metafield-compare__review" aria-label="${ratingText} out of 5, ${ratingCount} reviews">
      <span class="product-metafield-compare__review-stars" aria-hidden="true">
        <span>${stars}</span>
        <span class="product-metafield-compare__review-stars-fill" style="width: ${fillWidth}">${stars}</span>
      </span>
      <span>${ratingText} (${ratingCount})</span>
    </a>`;
  }

  function renderProductCell(product) {
    const image = product.image
      ? `<a href="${escapeHtml(product.url)}" class="product-metafield-compare__image-link"><img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="300" height="220"></a>`
      : '<div class="product-metafield-compare__image-placeholder"></div>';
    const comparePrice = product.compareAtPrice
      ? `<s class="product-metafield-compare__compare-price">${escapeHtml(product.compareAtPrice)}</s>`
      : '';

    return `<div class="product-metafield-compare__product">
      ${image}
      <div class="product-metafield-compare__price"><strong>${escapeHtml(product.price)}</strong>${comparePrice}</div>
      ${renderProductReview(product)}
      ${product.description ? `<p>${escapeHtml(product.description)}</p>` : ''}
    </div>`;
  }

  function initCompare(root) {
    if (root.dataset.compareInitialized === 'true') return;
    root.dataset.compareInitialized = 'true';

    const dataNode = root.querySelector('[data-compare-products-json]');
    const tableHost = root.querySelector('[data-compare-table-host]');
    const fallback = root.querySelector('[data-compare-fallback]');
    const status = root.querySelector('[data-compare-status]');
    const modelList = root.querySelector('[data-compare-model-list]');
    const featureList = root.querySelector('[data-compare-feature-list]');
    const modelCount = root.querySelector('[data-compare-model-count]');
    const featureCount = root.querySelector('[data-compare-feature-count]');
    const maxProducts = Math.max(2, Number(root.dataset.maxProducts || 4));
    const defaultProducts = Math.max(1, Number(root.dataset.defaultProducts || 2));
    const labels = {
      featureColumn: root.dataset.featureColumnLabel || 'Features',
      modelRow: root.dataset.modelRowLabel || 'E-bike model',
      specification: root.dataset.specificationLabel || 'Specifications',
      mechanical: root.dataset.mechanicalLabel || 'Mechanical',
      sizeImage: root.dataset.sizeLabel || 'Size & geometry',
      buyButton: root.dataset.buyButtonLabel || 'Shop now',
      remove: root.dataset.removeLabel || 'Remove',
      removeIcon: root.dataset.removeIcon || '',
      noProducts: root.dataset.emptyLabel || 'Select products to compare.',
      limit: root.dataset.limitMessage || `You can compare up to ${maxProducts} products.`,
    };

    let products = [];
    try {
      products = JSON.parse(dataNode ? dataNode.textContent : '[]');
    } catch (error) {
      announce(status, labels.noProducts);
      return;
    }

    products = products.filter((product) => product && product.handle);
    const productIds = products.map((product) => String(product.id));
    const identityMap = new Map();
    products.forEach((product) => {
      identityMap.set(String(product.id), String(product.id));
      identityMap.set(String(product.handle), String(product.id));
    });
    const resolveSelection = (values) => unique(values.map((value) => identityMap.get(String(value)) || ''));
    const urlSelection = selectedFromUrl();
    const storedSelection = readStorage(STORAGE_KEY);
    const legacySelection = storedSelection.length ? [] : readStorage(LEGACY_STORAGE_KEY);
    let selected = resolveSelection(urlSelection.length ? urlSelection : storedSelection.length ? storedSelection : legacySelection);
    if (!selected.length) selected = productIds.slice(0, defaultProducts);
    selected = selected.slice(0, maxProducts);

    function getSelectedProducts() {
      return selected
        .map((productId) => products.find((product) => String(product.id) === productId))
        .filter(Boolean);
    }

    let groups = buildGroups(getSelectedProducts(), labels);
    let allFeatureKeys = groups.flatMap((group) => group.rows.map((row) => row.key));
    const storedFeatures = readStorage(FEATURE_STORAGE_KEY);
    let selectedFeatures = storedFeatures.length
      ? storedFeatures.filter((key) => allFeatureKeys.includes(key))
      : [...allFeatureKeys];

    function refreshGroups() {
      const previousKeys = [...allFeatureKeys];
      const previousSelection = [...selectedFeatures];
      const allPreviouslySelected = previousKeys.length > 0 && previousKeys.every((key) => previousSelection.includes(key));

      groups = buildGroups(getSelectedProducts(), labels);
      allFeatureKeys = groups.flatMap((group) => group.rows.map((row) => row.key));
      selectedFeatures = previousSelection.filter((key) => allFeatureKeys.includes(key));

      if (allPreviouslySelected || (!previousKeys.length && !previousSelection.length)) {
        selectedFeatures = [...allFeatureKeys];
        return;
      }

      allFeatureKeys.forEach((key) => {
        if (!previousKeys.includes(key) && !selectedFeatures.includes(key)) selectedFeatures.push(key);
      });
    }

    function saveSelection() {
      writeStorage(STORAGE_KEY, selected);
      updateCompareUrl(selected);
      broadcast(selected);
    }

    function renderSelectors() {
      if (modelList) {
        modelList.innerHTML = products
          .map(
            (product) => `<label class="product-metafield-compare__option">
              <input type="checkbox" data-compare-model-option value="${escapeHtml(product.id)}" ${selected.includes(String(product.id)) ? 'checked' : ''}>
              <span>${escapeHtml(product.title)}</span>
            </label>`
          )
          .join('');
      }

      if (featureList) {
        featureList.innerHTML = groups
          .filter((group) => group.rows.length)
          .map(
            (group) => `<div class="product-metafield-compare__option-group">
              <strong>${escapeHtml(group.label)}</strong>
              ${group.rows
                .map(
                  (row) => `<label class="product-metafield-compare__option">
                    <input type="checkbox" data-compare-feature-option value="${escapeHtml(row.key)}" ${selectedFeatures.includes(row.key) ? 'checked' : ''}>
                    <span>${escapeHtml(row.label)}</span>
                  </label>`
                )
                .join('')}
            </div>`
          )
          .join('');
      }

      if (modelCount) modelCount.textContent = String(selected.length);
      if (featureCount) featureCount.textContent = String(selectedFeatures.length);
    }

    function renderTable() {
      const selectedProducts = getSelectedProducts();

      if (!tableHost) return;
      if (!selectedProducts.length) {
        tableHost.innerHTML = `<div class="product-metafield-compare__empty">${escapeHtml(labels.noProducts)}</div>`;
        return;
      }

      const removeButtonContent = labels.removeIcon
        ? `<img src="${escapeHtml(labels.removeIcon)}" alt="" width="48" height="48">`
        : '&times;';
      const removeButtonClass = labels.removeIcon ? ' class="has-image"' : '';

      let html = `<div class="product-metafield-compare__table-box"><table class="product-metafield-compare__table">
        <thead><tr class="product-metafield-compare__title-row">
          <th>${escapeHtml(labels.featureColumn)}</th>
          ${selectedProducts
            .map(
              (product) => `<th><div class="product-metafield-compare__title-content"><span>${escapeHtml(product.title)}</span><button type="button"${removeButtonClass} data-compare-remove="${escapeHtml(product.id)}" aria-label="${escapeHtml(labels.remove)} ${escapeHtml(product.title)}" title="${escapeHtml(labels.remove)}">${removeButtonContent}</button></div></th>`
            )
            .join('')}
        </tr></thead><tbody>
        <tr class="product-metafield-compare__model-row"><th>${escapeHtml(labels.modelRow)}</th>
          ${selectedProducts.map((product) => `<td>${renderProductCell(product)}</td>`).join('')}
        </tr>`;

      groups.forEach((group) => {
        const visibleRows = group.rows.filter((row) => selectedFeatures.includes(row.key));
        if (!visibleRows.length) return;

        const valueMaps = selectedProducts.map((product) => productValueMap(product, group));
        visibleRows.forEach((row) => {
          html += `<tr class="product-metafield-compare__feature-row"><th>${escapeHtml(row.label)}</th>`;
          selectedProducts.forEach((_product, index) => {
            html += `<td>${escapeHtml(valueMaps[index].get(row.key) || '-')}</td>`;
          });
          html += '</tr>';
        });
      });

      html += `<tr class="product-metafield-compare__bottom-row"><th></th>${selectedProducts
        .map((product) => `<td><a href="${escapeHtml(product.url)}" class="product-metafield-compare__buy">${escapeHtml(labels.buyButton)}</a></td>`)
        .join('')}</tr></tbody></table></div>`;

      tableHost.innerHTML = html;
    }

    function render() {
      refreshGroups();
      renderSelectors();
      renderTable();
      if (fallback) fallback.hidden = true;
      root.classList.remove('is-initializing');
      root.classList.add('is-ready');
    }

    const selectors = [...root.querySelectorAll('.product-metafield-compare__selector')];
    function closeSelector(selector, restoreFocus) {
      if (!selector || !selector.open) return;
      selector.open = false;
      if (restoreFocus) {
        const summary = selector.querySelector('summary');
        if (summary) summary.focus();
      }
    }

    selectors.forEach((selector) => {
      selector.addEventListener('toggle', () => {
        if (!selector.open) return;
        selectors.forEach((other) => {
          if (other !== selector) closeSelector(other, false);
        });
      });
    });

    document.addEventListener('pointerdown', (event) => {
      selectors.forEach((selector) => {
        if (selector.open && !selector.contains(event.target)) closeSelector(selector, false);
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openSelector = selectors.find((selector) => selector.open);
      if (!openSelector) return;
      event.preventDefault();
      closeSelector(openSelector, true);
    });

    root.addEventListener('change', (event) => {
      const modelOption = event.target.closest('[data-compare-model-option]');
      if (modelOption) {
        const productId = String(modelOption.value);
        if (modelOption.checked && !selected.includes(productId)) {
          if (selected.length >= maxProducts) {
            modelOption.checked = false;
            announce(status, labels.limit);
            return;
          }
          selected.push(productId);
        } else if (!modelOption.checked) {
          selected = selected.filter((item) => item !== productId);
        }
        announce(status, '');
        saveSelection();
        render();
        return;
      }

      const featureOption = event.target.closest('[data-compare-feature-option]');
      if (featureOption) {
        const key = String(featureOption.value);
        if (featureOption.checked && !selectedFeatures.includes(key)) selectedFeatures.push(key);
        else if (!featureOption.checked) selectedFeatures = selectedFeatures.filter((item) => item !== key);
        writeStorage(FEATURE_STORAGE_KEY, selectedFeatures);
        render();
      }
    });

    root.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-compare-close]');
      if (closeButton) {
        closeSelector(closeButton.closest('.product-metafield-compare__selector'), true);
        return;
      }

      if (event.target.matches('.product-metafield-compare__selector[open]')) {
        closeSelector(event.target, false);
        return;
      }

      const removeButton = event.target.closest('[data-compare-remove]');
      if (removeButton) {
        selected = selected.filter((productId) => productId !== String(removeButton.dataset.compareRemove));
        saveSelection();
        render();
        return;
      }

      const action = event.target.closest('[data-compare-action]');
      if (!action) return;
      const value = action.dataset.compareAction;
      if (value === 'models-all') selected = productIds.slice(0, maxProducts);
      if (value === 'models-clear') selected = [];
      if (value === 'features-all') selectedFeatures = [...allFeatureKeys];
      if (value === 'features-clear') selectedFeatures = [];
      writeStorage(FEATURE_STORAGE_KEY, selectedFeatures);
      saveSelection();
      render();
    });

    document.addEventListener(CHANGE_EVENT, (event) => {
      const next = unique(event.detail && event.detail.handles ? event.detail.handles : []);
      selected = resolveSelection(next).slice(0, maxProducts);
      render();
    });

    saveSelection();
    render();
  }

  function init(container) {
    const scope = container || document;
    scope.querySelectorAll('[data-product-series-compare]').forEach(initSeries);
    scope.querySelectorAll('[data-product-metafield-compare]').forEach(initCompare);
  }

  function boot() {
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }

  if (!window.GleecycleProductCompare) {
    window.GleecycleProductCompare = { init };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  } else {
    window.GleecycleProductCompare.init(document);
  }
})();
